export const STORAGE_KEY = {
    TOKEN: '01',
    COOKIE_INFO: '02',
    USER_INFO: '03',
    PLAYER_INFO: '04',
    SERVER_INFO: '05',
    LOGIN_TOKEN: '06',
}